import BrowserService from '@/services/browserService'

export default () => {
    window.dataLayer?.push({
        event: 'logout',
        platform: BrowserService.platform(),
        sessionId: BrowserService.sessionId(),
        user_id: null,
        _clear: true,
    })
}
